﻿import React, { useState, useEffect } from 'react';
import GlobalDialog from '../Modal/GlobalDialog';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType, PrecautionaryStatementTypes } from '../../models/enums';
import { PrecautionaryStatement } from '../../models/Common/precautionary-statement';
import { ToastProps } from '../../models/toast-props';
import { CrudFunctions } from '../../utilities/crud-functions';

import DmaFooter from '../DmaFooter';

import List from 'devextreme-react/list';
import SelectBox from 'devextreme-react/select-box';
import Button from 'devextreme-react/button';
import Toast from 'devextreme-react/toast';

let key = 0;

export default function PrecautionaryStatementsMaintenanceForm() {
    const [generalPrecautionaryStatements, setGeneralPrecautionaryStatements] =
        useState<PrecautionaryStatement[]>();

    const [preventionPrecautionaryStatements, setPreventionPrecautionaryStatements] =
        useState<PrecautionaryStatement[]>();

    const [responsePrecautionaryStatements, setResponsePrecautionaryStatements] =
        useState<PrecautionaryStatement[]>();

    const [storagePrecautionaryStatements, setStoragePrecautionaryStatements] =
        useState<PrecautionaryStatement[]>();

    const [disposalPrecautionaryStatements, setDisposalPrecautionaryStatements] =
        useState<PrecautionaryStatement[]>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    const [toastProps, setToastProps] =
        useState<ToastProps>();

    useEffect(() => {
        getAllData();
    }, []);

    key++;

    return (
        <div className="pw-content">
            <div className="lq-title-bar pw-form-header">
                <div className="lq-main-title">Precautionary Statements</div>

                <div className="title-bar-spacer" />
                <div className="save-toolbar">
                    <Button id="goBackButton" text="" icon="arrowleft" type="normal"
                        hint="go back"
                        height={'2.6em'}
                        onClick={goBack} />
                </div>
            </div>

            <div className="pw-margin-top-1">
                <div className="pw-form-unit-label">General Precautionary: Prevention</div>
                <div className="pw-form-unit pw-bg-rb-100 pw-default-border">
                    <List height="100%"
                        selectionMode="none"
                        dataSource={generalPrecautionaryStatements ?
                            generalPrecautionaryStatements : []}
                        itemRender={renderPrecautionaryStatement} />
                </div>
            </div>

            <div className="pw-margin-top-1">
                <div className="pw-form-unit-label">Prevention Precautionary Statements</div>
                <div className="pw-form-unit pw-bg-rb-100 pw-default-border">
                    <List height="100%"
                        selectionMode="none"
                        dataSource={preventionPrecautionaryStatements ?
                            preventionPrecautionaryStatements : []}
                        itemRender={renderPrecautionaryStatement} />
                </div>
            </div>

            <div className="pw-margin-top-1">
                <div className="pw-form-unit-label">Response Precautionary Statements</div>
                <div className="pw-form-unit pw-bg-rb-100 pw-default-border">
                    <List height="100%"
                        selectionMode="none"
                        dataSource={responsePrecautionaryStatements ?
                            responsePrecautionaryStatements : []}
                        itemRender={renderPrecautionaryStatement} />
                </div>
            </div>

            <div className="pw-margin-top-1">
                <div className="pw-form-unit-label">Storage Precautionary Statements</div>
                <div className="pw-form-unit pw-bg-rb-100 pw-default-border">
                    <List height="100%"
                        selectionMode="none"
                        dataSource={storagePrecautionaryStatements ?
                            storagePrecautionaryStatements : []}
                        itemRender={renderPrecautionaryStatement} />
                </div>
            </div>

            <div className="pw-margin-top-1">
                <div className="pw-form-unit-label">Disposal Precautionary Statements</div>
                <div className="pw-form-unit pw-bg-rb-100 pw-default-border">
                    <List height="100%"
                        selectionMode="none"
                        dataSource={disposalPrecautionaryStatements ?
                            disposalPrecautionaryStatements : []}
                        itemRender={renderPrecautionaryStatement} />
                </div>
            </div>

            <DmaFooter />

            {toastProps && toastProps.visible &&
                <Toast
                    visible={toastProps.visible}
                    message={toastProps.message}
                    type={toastProps.toastType}
                    onHiding={onToastHiding}
                    displayTime={600} />
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );

    async function getPrecautionaryStatements() {
        await CrudFunctions.getData("common/precautionarystatements")
            .then(data => {
                sortPrecautionaryStatements(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Technology List");
            });
    }

    function sortPrecautionaryStatements(statements: PrecautionaryStatement[]) {
        if (statements) {
            setGeneralPrecautionaryStatements(statements.filter(s => s.precautionaryStatementTypeId === PrecautionaryStatementTypes.General))
            setPreventionPrecautionaryStatements(statements.filter(s => s.precautionaryStatementTypeId === PrecautionaryStatementTypes.Prevention))
            setResponsePrecautionaryStatements(statements.filter(s => s.precautionaryStatementTypeId === PrecautionaryStatementTypes.Response))
            setStoragePrecautionaryStatements(statements.filter(s => s.precautionaryStatementTypeId === PrecautionaryStatementTypes.Storage))
            setDisposalPrecautionaryStatements(statements.filter(s => s.precautionaryStatementTypeId === PrecautionaryStatementTypes.Disposal))
        }
    }

    async function getAllData() {
        await Promise.all([
            getPrecautionaryStatements()
        ]);
    }

    //render

    function renderPrecautionaryStatement(e: any) {
       if (e) {
            let statement = e.statement ? e.statement.replace("(Obsolete)", "").trim() : "";

            return (
                <div><span className="pw-bold">{`${e.precautionaryCode}: `}</span>{e.obsolete && <span className="pw-red">(Obsolete)</span>}<span className="pw-margin-left-1">{statement}</span></div>
            );
        }
        else
            return <div></div>;
    }

    //navigation

    function goBack() {
        history.back();
    }

    function showToast(message: string, toastType: string) {
        let toastParams: ToastProps = {
            message: message,
            toastType: toastType,
            visible: true
        };

        setToastProps(toastParams);
    }

    function onToastHiding() {
        let toastParams: ToastProps = {
            message: undefined,
            toastType: undefined,
            visible: false
        };

        setToastProps(toastParams);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

}